import angular from 'angular';
import uiRouter from 'angular-ui-router';
import uiBootstrap from 'angular-ui-bootstrap';
import textAngular from 'textangular';
import textangularConfig from '../comment-section/textangular.decorator';
import SubcaseStateChangeService from './subcase-state-change-modal.service';

export default angular
  .module('verifyApp.subcase-state-change-modal', [uiRouter, uiBootstrap, textAngular])
  .config(textangularConfig)
  .service('SubcaseStateChangeService', SubcaseStateChangeService)
  .name;



// WEBPACK FOOTER //
// ./client/components/subcase-state-change-modal/index.js